export const FISH_SPECIES_LATIN_ERROR_KEY =
  "catch_fish_species_latin_required";

const LETTER_PATTERN = /\p{L}/u;
const LATIN_LETTER_PATTERN = /\p{Script=Latin}/u;
const COMBINING_MARK_PATTERN = /\p{M}/u;
const APPROVED_SEPARATOR_PATTERN = /[\s.'’‘()\-\u2010-\u2015]/u;

export function isValidFishSpeciesName(value) {
  const normalizedValue = String(value || "").trim();
  if (!normalizedValue) {
    return true;
  }

  return Array.from(normalizedValue).every((character) => {
    if (LETTER_PATTERN.test(character)) {
      return LATIN_LETTER_PATTERN.test(character);
    }

    return (
      COMBINING_MARK_PATTERN.test(character) ||
      APPROVED_SEPARATOR_PATTERN.test(character)
    );
  });
}

export function getFishSpeciesValidationErrorKey(value) {
  return isValidFishSpeciesName(value) ? "" : FISH_SPECIES_LATIN_ERROR_KEY;
}
